import { useCallback, useEffect, useState } from 'react'
import { mapOptions, russiaCenter } from '../../../../utils/constants'
import {
  Location,
  SlotItemInterface,
  TransportItemInterface,
} from '../../../../types/interfaces'
import {  useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectDarkTheme } from '../../../../../store/slices/settingsSlice'

export const useGMapForMarker = (
  center: Location,
  item: SlotItemInterface | TransportItemInterface,
) => {
  const [gMap, setGMap] = useState<google.maps.Map | undefined>(undefined)
  const location = useLocation()
  const [marker, setMarker] = useState<google.maps.marker.AdvancedMarkerElement | null>()
  const darkTheme = useSelector(selectDarkTheme)

  const setMarkerAction = useCallback(
    (title: string, gMap: google.maps.Map, locationData: Location) => {
      let marker = new google.maps.marker.AdvancedMarkerElement({
        position: {
          lat: parseFloat(String(locationData.lat)),
          lng: parseFloat(String(locationData.lng)),
        },
        map: gMap,
        title: title,
      })
      setMarker(marker)
      gMap.setCenter({
        lat: parseFloat(String(locationData.lat)),
        lng: parseFloat(String(locationData.lng)),
      })
      gMap && gMap.setZoom(location.pathname.split('/')[1] === 'slot' ? 15 : 10)

      // const markerContent = item.points
      //   ? `
      //               <div style="font-size:10px">${item.points[0].address.value}</div>
      //               `
      //   : ``

      // addInfoWindow(marker, markerContent)
    },
    [location.pathname],
  )

  const initMap = useCallback(
    (id: string) => {
      const el = document.getElementById(id)
      if (el && !gMap) {
        let map = new google.maps.Map(el, {
          zoom: 2,
          center: { lat: parseFloat(String(center.lat)), lng: parseFloat(String(center.lng)) }, // точка подачи и есть цент передавать в хук и в пропс
          ...mapOptions,
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          mapId: '2ae8a6eb45821208',
          colorScheme: darkTheme ? 'DARK' : 'LIGHT',
        })
        setGMap(map)

        if (item.points && item.points[0] && location.pathname.split('/')[2] === 'item') {
          setMarkerAction('', map, {
            lat: Number(
              item.points[0].address
                ? item.points[0].address.latitude
                : item.points[0].city.latitude,
            ),
            lng: Number(
              item.points[0].address
                ? item.points[0].address.longitude
                : item.points[0].city.longitude,
            ),
          })
        }
      }
    },
    [center.lat, center.lng, darkTheme, gMap, item.points, location.pathname, setMarkerAction],
  )

  function addInfoWindow(marker: google.maps.marker.AdvancedMarkerElement, message: string) {
    let infoWindow = new google.maps.InfoWindow({
      content: message,
      maxWidth: 150,
    })
    // google.maps.event.addListener(infoWindow, 'domready', function () {
    //   const attribute = marker.getAttributeNode('id')?.value
    //   if (attribute) {
    //     let clickDiv = document.getElementById(attribute)
    //     clickDiv &&
    //       clickDiv.addEventListener('click', () => {
    //         // toOrder(Number(marker.getAttribute()));
    //       })
    //   }
    // })
    google.maps.event.addListener(marker, 'click', function () {
      infoWindow.open(gMap, marker)
    })
  }

  useEffect(() => {
    initMap('map')
  }, [])

  useEffect(() => {
    if (marker) marker.map = null
    gMap && gMap.setCenter(russiaCenter)
    gMap && gMap.setZoom(2)
    if (gMap && item.points && item.points?.length > 0) {
      if (
        location.pathname.split('/')[1] === 'transport' &&
        item.points[0].city.latitude &&
        item.points[0].city.longitude
      ) {
        const coords = {
          lat: Number(item.points[0].city.latitude),
          lng: Number(item.points[0].city.longitude),
        }
        setMarkerAction('test', gMap, coords)
      }
      if (
        location.pathname.split('/')[1] === 'slot' &&
        item.points[0].address.latitude &&
        item.points[0].address.longitude
      ) {
        const coords = {
          lat: Number(item.points[0].address.latitude),
          lng: Number(item.points[0].address.longitude),
        }
        setMarkerAction('test', gMap, coords)
      }
    }
  }, [item.points])
}
